import MintableItem from "./MintableItem";

export default MintableItem;